export const routes = [
  //登录
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  // 主页
  {
    path: '/main',
    name: 'Main',
    component: () => import('../views/Main.vue'),
	children: [
		{
			path: 'home',
			name: 'Home',
			component: () => import('../mainviews/Home.vue')
		},
		{
			path: 'menu',
			name: 'Menu',
			component: () => import('../mainviews/Menu.vue')
		},
		{
			path: 'shopbag',
			name: 'Shopbag',
			component: () => import('../mainviews/Shopbag.vue')
		},
		{
			path: 'my',
			name: 'My',
			component: () => import('../mainviews/My.vue')
		}
	]
  },
  {
  	path: '/order',
  	name: 'Order',
  	component: () => import('../views/Order.vue')
  },
  {
	  path: '/detail',
	  name: 'Detail',
	  component: () => import('../views/Detail.vue'),
  },
  {
  	  path: '/newaddress',
  	  name: 'NewAddress',
  	  component: () => import('../views/NewAddress.vue'),
  },
  {
  	  path: '/myaddress',
  	  name: 'MyAddress',
  	  component: () => import('../views/MyAddress.vue'),
  },
  {
  	  path: '/acount',
  	  name: 'Acount',
  	  component: () => import('../views/Acount.vue'),
  },
  {
  	  path: '/checkorder',
  	  name: 'CheckOrder',
  	  component: () => import('../views/CheckOrder.vue'),
  },
  {
  	  path: '/like',
  	  name: 'Like',
  	  component: () => import('../views/Like.vue'),
  },
  {
  	  path: '/secure',
  	  name: 'Secure',
  	  component: () => import('../views/Secure.vue'),
  },
  {
  	  path: '/forgot',
  	  name: 'Forgot',
  	  component: () => import('../views/Forgot.vue'),
  },
  
  {
    //当以上路由不能匹配时，匹配path: * 路径
    path: '*',
    //路由重定向
    redirect: {
      name: 'Login'
    }
  },
  
]